import { createFeatureSelector } from '@ngrx/store';

import type { QuotationReactionState } from './email-quotation-reaction.reducer';

export const quotationReactionSelectorKey = 'quotationReaction';

export const getQuotationReactionStateState =
  createFeatureSelector<QuotationReactionState>(quotationReactionSelectorKey);
